import dayjs from 'dayjs';

// eslint-disable-next-line newline-per-chained-call
export const get12hOfDate = (date) => dayjs(date).hour(12).minute(0).second(0).millisecond(0);

export default {
  get12hOfDate,
};
